import BaseService from '../BaseService';

class SaleService extends BaseService {
    getAll = (filters) => this.post('/warehouse/report/sells', filters || { });
}

export default new SaleService();